import { Reservation } from 'modules/arena/reservations/types';
import { RESERVATION_STATUS_META } from 'modules/arena/reservations/content';
import { Badge } from 'shared/components/ui/Badge';
import { cn } from 'shared/utils/cn';
import { formatBRL } from 'shared/utils/format';

interface ReservationRowProps {
  reservation: Reservation;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function ReservationRow({ reservation, isSelected, onSelect }: ReservationRowProps) {
  const statusMeta = RESERVATION_STATUS_META[reservation.status];

  return (
    <button
      type="button"
      onClick={() => onSelect(reservation.id)}
      className={cn(
        'flex w-full flex-col gap-1 rounded-xl border p-4 text-left transition-colors',
        isSelected ? 'border-primary bg-accent-soft/30' : 'border-border/40 hover:border-primary'
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-ink">{reservation.id}</span>
        <Badge tone={statusMeta.tone}>{statusMeta.label}</Badge>
      </div>

      <p className="text-sm text-ink">
        {reservation.courtName} · {reservation.sport}
      </p>
      <p className="text-xs text-ink-secondary">
        {reservation.dateLabel} · {reservation.timeLabel} · {reservation.responsiblePlayer}
      </p>

      <div className="mt-1 flex items-center justify-between">
        <span className="text-sm font-medium text-ink">{formatBRL(reservation.totalAmount)}</span>
        {reservation.expiresAtLabel && (
          <span className="text-xs text-warning">expira {reservation.expiresAtLabel}</span>
        )}
      </div>
    </button>
  );
}
